import axios from './axiosConfig';

export const hasPermission = async (user, permission) => {
  if (!user) return false;
  
  const token = localStorage.getItem('token');
  if (!token) {
    return false;
  }
  try {
    const { data } = await axios.get(`/permissions/${permission}`, {
      headers: {
        'Authorization': `Bearer ${token}`,
      },
    });

    // 權限檢查邏輯
    const {
      required_loginType,
      required_e_ssid,
      required_e_position,
      required_e_id
    } = data;


    const loginTypeCheck = !required_loginType || user.loginType === required_loginType;
    const eSsidCheck = !required_e_ssid || user.e_ssid === required_e_ssid;
    const ePositionCheck = !required_e_position || user.e_position === required_e_position;
    const eIdCheck = !required_e_id || user.e_id === required_e_id;
    
    return loginTypeCheck && eSsidCheck && ePositionCheck && eIdCheck;
  } catch (error) {
    return false;
  }
};

